import axios from "axios";
import { backend_url } from "../../utils/config.js";

const state = {
  products: [],
  totalProducts: 0,
  currentPage: 1,
  totalPages: 1,
};

const getters = {
  getProducts: (state) => state.products,
  getTotalProducts: (state) => state.totalProducts,
  getCurrentProductPage: (state) => state.currentPage,
  getTotalProductPages: (state) => state.totalPages,
};

const actions = {
  PRODUCTS_REQUEST: ({ commit }, params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {
          page = 1,
          limit = 25,
          client = "all",
          status = "all",
          validity = "all",
          search = "",
        } = params;

        const queryParams = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          client,
          status,
          validity,
          ...(search && { search }),
        });

        const { data } = await axios.get(
          `${backend_url}/product?${queryParams.toString()}`
        );
        commit("GET_PRODUCTS", {
          products: data.products,
          total: data.total,
          page: data.page,
          totalPages: data.totalPages,
        });
        resolve(data);
      } catch (err) {
        commit("PRODUCT_ERROR");
        reject(err);
      }
    });
  },
  ADD_PRODUCT: ({ commit }, product) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post(`${backend_url}/product`, product);
        resolve(data);
      } catch (err) {
        commit("PRODUCT_ERROR");
        reject(err);
      }
    });
  },
  // PREVIOUS IMPLEMENTATION

  // REMOVE_PRODUCT: ({ commit }, { _id, visibility }) => {
  //   return new Promise(async (resolve, reject) => {
  //     try {
  //       const { data } = await axios.patch(`${backend_url}/product/${_id}`, {
  //         visibility,
  //       });
  //       resolve(data);
  //     } catch (err) {
  //       commit("PRODUCT_ERROR");
  //       reject(err);
  //     }
  //   });
  // },
  DELETE_PRODUCT: ({ commit }, { _id }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.delete(`${backend_url}/product/${_id}`);
        commit("UPDATE_DELETED_PRODUCTS", _id);
        resolve(data);
      } catch (err) {
        commit("PRODUCT_ERROR");
        reject(err);
      }
    });
  },
  UPDATE_PRODUCT: ({ commit }, { _id, payload }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.patch(
          `${backend_url}/product/${_id}`,
          payload
        );
        commit("UPDATE_UPDATED_PRODUCTS", { _id, payload });
        resolve(data);
      } catch (err) {
        commit("PRODUCT_ERROR");
        reject(err);
      }
    });
  },
};

const mutations = {
  UPDATE_UPDATED_PRODUCTS: (state, { _id, payload }) => {
    const list = state.products.map((elem) => {
      if (elem._id == _id) {
        return {
          ...elem,
          ...payload,
        };
      }
      return elem;
    });

    state.products = list;
  },
  UPDATE_DELETED_PRODUCTS: (state, id) => {
    state.products = state.products.filter((product) => product._id !== id);
    // Update total count (component should refetch for accurate count)
    state.totalProducts = Math.max(0, state.totalProducts - 1);
  },
  GET_PRODUCTS: (state, { products, total, page, totalPages }) => {
    state.products = products;
    state.totalProducts = Number(total) || 0;
    state.currentPage = Number(page) || 1;
    state.totalPages = Number(totalPages) || 1;
  },
  PRODUCT_ERROR: (state) => {
    state.products = [];
    state.totalProducts = 0;
    state.currentPage = 1;
    state.totalPages = 1;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
